<template>
  <div class="app-box">
    <div id="app" class="vertical">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import utils from '@/utils';
let topBgJson = {
  '1661646476045791233': '/images/top-bg.png',
  '1685691294666067969': '/images/top-bg-kfey.png',
  '1740610734071193602': '/images/bottom-bg-scyy.jpg',
  '1751524915423117313': '/images/bottom-bg-hnfy.jpg',
}
let bottomBgJson = {
  '1661646476045791233': '/images/bottom-bg.png',
  '1685691294666067969': '/images/bottom-bg-kfey.png',
  '1740610734071193602': '/images/bottom-bg-scyy.jpg',
  '1751524915423117313': '/images/bottom-bg-hnfy.jpg',
}
export default {
  data () {
    return {
      // topBg: ''
    }
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    topBg () {
      return this.buildInfo.buildId ? topBgJson[this.buildInfo.buildId] : '';
    },
    bottomBg () {
      return this.buildInfo.buildId ? bottomBgJson[this.buildInfo.buildId] : '';
    }
  },
  created () {
    // 禁止鼠标右键
    document.onmousedown = function () {
      if (event.button === 2) {
        event.returnValue = false;
      }
    };
  },
  mounted () {
    this.isPortraitFn();
    // 添加窗口大小变化的事件监听器
    // const _throttle = utils.throttle(this.isPortraitFn, 30);
    window.addEventListener('resize', this.isPortraitFn);
  },
  methods: {
    ...mapActions('app', [
      // 调用定时器
      'isPortraitFn'
    ])
  }
}
</script>

<style lang="scss">
.app-box {
  height: 100vh;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.top-bg {
  position: relative;
  display: none;
  background: #000;
}
.top-box {
  width: 100vw;
  height: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.hospital-name {
  width: 100vw;
  height: 74px;
  text-align: center;
  margin-top: 30px;
  font-size: 74px;
  color: #fff;
  text-shadow: 1px 1px 2px black;
}

.hospital-txt {
  width: 100vw;
  height: 74px;
  text-align: center;
  margin-top: 30px;
  font-size: 60px;
  color: #fff;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  height: 100%;
}

.text-shadow {
  text-shadow: 1px 1px 1px #000
}
@media (orientation: portrait) {
  body {
      background-color: #D8D8D8;
  }
  .el-message {
    top: 23vh !important;
  }
  #app {
  // height: 72.19vh;
  position: relative;
  }
  .top-bg {
    display: block;
    height: 11.35vh;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      height: 12.6vh;
      z-index: 1;
    }
    .img-logo {
      height: 9vh;
      z-index: 1;
    }
  }
  .bottom-bg {
    height: 16.46vh;
    background: #000;
    background-size: cover !important;
  }
}
</style>
